// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
  padding: 48px 16px;
}

.profile-card {
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  box-shadow: 0 8px 24px var(--shadow);
  overflow: hidden;
}

.profile-header {
  background: var(--primary);
  color: #fff;
  padding: 28px 20px;
  text-align: center;
}

.profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.92);
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 24px;
  margin: 0 auto 10px;
}

.profile-header h5 {
  color: #fff;
  margin: 0;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.profile-header small {
  opacity: 0.8;
}

.profile-body {
  padding: 24px;
}

.profile-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
}

.profile-row-label {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-secondary);
}

.profile-row-value {
  color: var(--text-primary);
  font-weight: 600;
}

.profile-section-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin-bottom: 8px;
}

/* Rows that are also interactive controls (theme toggle, links to
   other pages) — same layout as a plain profile-row, but clickable. */
.profile-row-action {
  width: 100%;
  background: transparent;
  border: none;
  border-radius: var(--radius-sm);
  padding: 8px 6px;
  margin: 0 -6px;
  cursor: pointer;
  transition: background 0.15s ease;
}
.profile-row-action:hover {
  background: var(--hover);
}

.profile-row-link .profile-row-label {
  color: var(--text-primary);
}

.profile-row-chevron {
  color: var(--text-muted);
  width: 14px;
  height: 14px;
}

@media (max-width: 480px) {
  .profile-page {
    padding: 24px 12px;
  }
  .profile-body {
    padding: 18px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;sEACsE;AACtE;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF","sourcesContent":[".profile-page {\n  padding: 48px 16px;\n}\n\n.profile-card {\n  background: var(--card-bg);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  box-shadow: 0 8px 24px var(--shadow);\n  overflow: hidden;\n}\n\n.profile-header {\n  background: var(--primary);\n  color: #fff;\n  padding: 28px 20px;\n  text-align: center;\n}\n\n.profile-avatar {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.92);\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  font-size: 24px;\n  margin: 0 auto 10px;\n}\n\n.profile-header h5 {\n  color: #fff;\n  margin: 0;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n}\n\n.profile-header small {\n  opacity: 0.8;\n}\n\n.profile-body {\n  padding: 24px;\n}\n\n.profile-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 0;\n}\n\n.profile-row-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text-secondary);\n}\n\n.profile-row-value {\n  color: var(--text-primary);\n  font-weight: 600;\n}\n\n.profile-section-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  margin-bottom: 8px;\n}\n\n/* Rows that are also interactive controls (theme toggle, links to\n   other pages) — same layout as a plain profile-row, but clickable. */\n.profile-row-action {\n  width: 100%;\n  background: transparent;\n  border: none;\n  border-radius: var(--radius-sm);\n  padding: 8px 6px;\n  margin: 0 -6px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.profile-row-action:hover {\n  background: var(--hover);\n}\n\n.profile-row-link .profile-row-label {\n  color: var(--text-primary);\n}\n\n.profile-row-chevron {\n  color: var(--text-muted);\n  width: 14px;\n  height: 14px;\n}\n\n@media (max-width: 480px) {\n  .profile-page {\n    padding: 24px 12px;\n  }\n  .profile-body {\n    padding: 18px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
